import { useComponentInViewport } from 'core-lib/hooks/useComponentInViewport';
import formatCurrency from 'core-lib/utils/currency';
import * as React from 'react';
import { Typography } from 'ui-v2/components/Typography';
import VideoCard from '../VideoCard';
import s from './VideoListingCard.module.scss';
import classNames from 'classnames';

type VideoListingProps = {
  title: string;
  subTitle: string;
  videoUrl: any;
  icon: string;
  price: number;
  discountedPrice: number;
  onVideoEnd?: () => void;
  playVideoObj: any;
  idx?: number;
  id?: string;
};
export const VideoListingCard: React.FunctionComponent<VideoListingProps> = ({
  title,
  subTitle,
  videoUrl,
  icon,
  price,
  discountedPrice,
  onVideoEnd,
  playVideoObj = {},
  idx,
  id,
}) => {
  const cardRef = React.useRef();

  const isInViewPort = useComponentInViewport(cardRef, {
    threshold: 0.8,
  });

  const isActive = React.useMemo(
    () => isInViewPort && !!playVideoObj?.[idx - 1],
    [isInViewPort, playVideoObj, idx]
  );

  return (
    <div className={s.root}>
      <div className={s.videoCard} ref={cardRef} id={id} data-index={idx}>
        <VideoCard
          url={videoUrl}
          thumbnailUrl={icon}
          showControls={false}
          isActive={isInViewPort}
          onVideoEnd={() => {
            onVideoEnd();
          }}
          key={isInViewPort ? `${idx}active` : `${idx}inactive`}
        />
      </div>
      <div className={s.cardContent}>
        <Typography
          label={subTitle}
          variant="tiny_extended_semi_bold"
          color="on_dark_bg"
          className={s.subTitle}
        />
        <Typography
          label={title}
          variant="label_3_medium"
          color="on_dark_bg"
          className={s.title}
        />
        <div className={s.priceBox}>
          <Typography
            label={formatCurrency(discountedPrice)}
            variant="label_3_bold"
            color="on_dark_bg"
            className={s.priceText}
          />
          <Typography
            label={formatCurrency(price)}
            variant="label_3_regular"
            color="tertiary"
            className={classNames(s.priceText, s.lineThrough)}
          />
        </div>
      </div>
    </div>
  );
};
